import { useConfig } from '../../../contexts'
import CreateAccountFormCognitoDev from './CognitoDev/Form'
import CreateAccountFormCoinhub from './Coinhub/Form'

const CreateAccountForm = (): JSX.Element => {
    const { firm } = useConfig()
    return (
        <div className="CreateAccountForm">
            {firm === 'CognitoDev' ? <CreateAccountFormCognitoDev /> : <></>}
            {firm === 'Coinhub' ? <CreateAccountFormCoinhub /> : <></>}
        </div>
    )
}

export default CreateAccountForm
